import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { FieldLabel } from 'components/forms'
import { FormattedDistance } from 'shared/units'
import Select from 'react-select'
import { Button } from 'components/util'
import RouteSelectModal from './RouteSelectModal'
import * as user from 'services/user/selectors'
import * as routeActions from 'services/routes/actions'
import styles from './_routeSelector.css'
import RouteItem from './RouteItem'

const mapStateToProps = (state) => ({
  userId: user.selectUserId(state),
})

const mapDispatchToActions = {
  ...routeActions,
}

export class RouteSelector extends Component {

  static propTypes = {
    route: PropTypes.object,
    onClearRoute: PropTypes.func,
    onChange: PropTypes.func,
    className: PropTypes.string,
    userId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    searchMyRoutesByName: PropTypes.func,
    loadMyRoutesPage: PropTypes.func,
  }

  static defaultProps = {
    onChange: () => {},
  }

  state = {
    showRouteModal: false,
    value: '',
  }

  componentWillMount () {
    // prime cache for the modal
    return this.props.loadMyRoutesPage({
      cache: null,
      limit: 20,
      offset: 0,
      userId: this.props.userId,
      searchTerm: '',
      orderBy: '-date_created',
    })
  }

  componentWillReceiveProps (nextProps) {
    if (!!this.props.route && nextProps.route === null) {
      this.setState({ value: '' })
    }
  }

  handleShowRouteModal = () => {
    this.setState({ showRouteModal: true })
  }

  handleHideRouteModal = () => {
    this.setState({ showRouteModal: false })
  }

  loadOptions = (input) => {
    const { userId } = this.props
    return this.props.searchMyRoutesByName({ text: input, userId })
      .then(({ value }) => {
        const routes = value.data._embedded.routes

        const options = routes.map(route => ({
          ...route,
          value: route,
          label: route.name,
        }))

        return { options }
      })
  }

  handleChangeRoute = (value) => {
    this.setState({ value })
    this.props.onChange(value)
    this.handleHideRouteModal()
  }

  renderOption = (value) => (option) => {
    return (
      <div className={classnames(styles.option, { [styles.value]: value })}>
        <img
          className={styles.optionThumbnail}
          src={option._links.thumbnail[0].href}
        />
        <div className={styles.optionInfo}>
          <div className={styles.optionTitle}>{option.name}</div>
          <div className={styles.optionDetails}>
            <FormattedMessage
              id='workouts.create.route.details'
              defaultMessage='{distance} in {city}, {state}, {country}'
              values={{
                distance: <FormattedDistance value={option.distance} digits={1} />,
                city: option.city,
                state: option.state,
                country: option.country && option.country.toUpperCase(),
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  render () {
    const { route, onClearRoute, className } = this.props
    const { showRouteModal } = this.state
    const AsyncComponent = Select.Async

    return (
      <div className={classnames(styles.container, className)}>

        <FieldLabel
          bold
          labelComponent={(
            <FormattedMessage
              id='workouts.create.route'
              defaultMessage='Route'
            />
          )}
        />

        {route ?
          <div className={styles.selectedRoute}>
            <RouteItem
              route={route}
              className={styles.selectedRouteItem}
            />
            <Button
              size='small'
              type='default'
              icon='x'
              onClick={onClearRoute}
            >
              <FormattedMessage
                id='workouts.create.clear_route'
                defaultMessage='Clear route'
              />
            </Button>
          </div>
        :
          <div className={styles.control}>
            <AsyncComponent
              multi={false}
              className={styles.select}
              value={this.state.value}
              onChange={this.handleChangeRoute}
              loadOptions={this.loadOptions}
              optionRenderer={this.renderOption()}
              valueRenderer={this.renderOption(true)}
            />
            <Button
              icon='search'
              onClick={this.handleShowRouteModal}
              className={styles.myRoutesButton}
            >
              <span className={styles.myRoutesButtonText}>
                <FormattedMessage
                  id='workouts.create.my_routes'
                  defaultMessage='My Routes'
                />
              </span>
            </Button>
          </div>
        }

        <RouteSelectModal
          isOpen={showRouteModal}
          onRequestedClose={this.handleHideRouteModal}
          onSelectRoute={this.handleChangeRoute}
        />

      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(RouteSelector)
